var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5 18.1966C38.5 30.9239 22 41.833 22 41.833C22 41.833 5.5 30.9239 5.5 18.1966C5.5 13.8567 7.23839 9.69458 10.3327 6.62581C13.4271 3.55703 17.6239 1.83301 22 1.83301C26.3761 1.83301 30.5729 3.55703 33.6673 6.62581C36.7616 9.69458 38.5 13.8567 38.5 18.1966ZM22 23.6512C25.0376 23.6512 27.5 21.2091 27.5 18.1966C27.5 15.1842 25.0376 12.7421 22 12.7421C18.9624 12.7421 16.5 15.1842 16.5 18.1966C16.5 21.2091 18.9624 23.6512 22 23.6512Z",
    fill: "#FAFAFA",
    fillOpacity: 0.980392,
    stroke: "#2E1A47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.b1e94054d9b688298543af5ebe8dbed3.svg";
export { ForwardRef as ReactComponent };